import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  styleUrl: './auth-header.component.scss'
})
export class AuthHeaderComponent {
  @Input() appTitle: string = environment.appTitle;
  @Input() appSubtitle: string = environment.appSubtitle;
  @Input() appUrl: string = environment.appUrl;
  @Input() isStageEnvironment =
    window.location.href.toLocaleLowerCase().indexOf('stage') !== -1 ||
    window.location.href.indexOf('local') !== -1
      ? true
      : false;

  constructor(private router: Router) {}

  onLogoClick(): void {
    this.router.navigate([this.appUrl]);
  }
}